import { produce } from 'immer';
import type { Reducer } from 'redux';
import type { LegacyAction } from '~/types/actions.types';
import * as AuthenticationActions from '~/ducks/authentication/actions';
import { fetchCurrentUserThunk } from '~/ducks/authentication/thunks';
import type { MenuState } from './data/MenuState';
import { composeLeftSection, composeRightSection } from './utils';

const initialMenuState: MenuState = {
  leftSection: [],
  rightSection: [],
};

const reducer: Reducer<MenuState, LegacyAction> = (state = initialMenuState, action) => {
  return produce(state, (draft) => {
    switch (action.type) {
      // The launch-time user fetch. Without it the menu waits for the post-launch background
      // refresh, and stays empty whenever that refresh fails.
      case fetchCurrentUserThunk.fulfilled.type:
      case AuthenticationActions.populateAuthentication.type: {
        draft.leftSection = composeLeftSection(action.payload.permissions);
        draft.rightSection = composeRightSection(
          action.payload.permissions,
          action.payload.utcMarket
        );
        return draft;
      }

      case AuthenticationActions.fetchUserInfoFromFleet.success: {
        draft.leftSection = composeLeftSection(action.response.permissions);
        draft.rightSection = composeRightSection(
          action.response.permissions,
          action.response.utcMarket
        );
        return draft;
      }

      default:
        return draft;
    }
  });
};

export default reducer;
